import { useTranslation } from 'react-i18next'

export const useColon = () => {
  const { i18n } = useTranslation()
  return i18n.language === 'zh-TW' ? '：' : ': '
}

export default useColon
